// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_gc-0";
export var optionCard = "_gc-1";